export default __webpack_public_path__ + "static/media/mascots.3011961e.png";